import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import editGreenIcon from 'assets/images/icons/edit-green.svg';
import crossIcon from 'assets/images/icons/cross-grey.svg';
import checkGreyIcon from 'assets/images/icons/check-grey.svg';
import TextField from 'components/form-components/TextField';
import { validateSqlColumnName } from 'pages/forms/utils';

function DBNameEditable({ data, column, callback }) {
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState('');

  const disabled = data.formStatus !== 'active' || !data.publishedVersion || data[column];

  const handleEdit = () => {
    setLocalValue(data[column]);
    setIsEditing(true);
  };

  const handleChange = (field, value) => {
    if (validateSqlColumnName(value)) {
      setLocalValue(value);
    }
  };

  const handleSave = async () => {
    setIsEditing(false);
    callback.updateTableData(data.formId, column, null, 'other', null, null, localValue);
  };

  const handleCancel = useCallback(() => {
    setLocalValue(data[column] ?? '');
    setIsEditing(false);
  }, [data, column]);

  // reset the fields when pagination changes
  useEffect(() => {
    setIsEditing(false);
    setLocalValue('');
  }, [data]);

  return (
    <div
      className={`d-flex justify-content-between align-items-center gap-2 ${
        disabled ? 'opacity-50' : ''
      }`}
    >
      {!isEditing ? (
        <>
          <span className='d-inline-block max-width'>{data[column]}</span>
          <img
            className={!disabled ? 'cursor-pointer' : 'cursor-not-allowed'}
            src={editGreenIcon}
            onClick={!disabled ? handleEdit : undefined}
          />
        </>
      ) : (
        <>
          <div className='flex-grow-1' style={{ minWidth: '10rem' }}>
            <TextField
              value={localValue}
              name='dbName'
              handleChange={handleChange}
              placeholder='field_search'
              shrink
            />
          </div>
          <div className='d-flex gap-3'>
            <img
              className={`cursor-pointer ${
                localValue.trim().length > 0 ? '' : 'pe-none opacity-50'
              }`}
              src={checkGreyIcon}
              onClick={handleSave}
            />
            <img className='cursor-pointer' src={crossIcon} onClick={handleCancel} />
          </div>
        </>
      )}
    </div>
  );
}

DBNameEditable.propTypes = {
  callback: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  column: PropTypes.string,
};

export default DBNameEditable;
